export const hgoHydrotreaterCodeCompletions = [
  { label: 'HGOYield', type: 'variable', info: '' },
  { label: 'LGOYield', type: 'variable', info: '' },
  { label: 'NaphthaYield', type: 'variable', info: '' },
  { label: 'H2SProductionRate', type: 'variable', info: '' },
  { label: 'HydrogenUseRate', type: 'variable', info: '' },
];
